<template>
    <v-container :center="!(items.total > 0)" :mob-mt56="items.total > 0" :loading="loading">
        <template #header>
            <v-container-header :to="{ name: 'tools.builder' }">Назад</v-container-header>
        </template>
        <template v-if="items.total > 0">
            <div class="builder-box__body-title df-space-between">
                <div class="create-course-box__body-title-name size-sm">Страницы</div>
                <div class="course-created__actions builder-tab-desk-visible">
                    <div class="course-created__action">
                        <v-btn :to="{ name: 'tools.landings.create' }">Создать новую страницу</v-btn>
                    </div>
                </div>
            </div>
            <div v-for="(item, index) in items.data" class="builder-box__pages-options" :key="`landing-${item.id}`">
                <router-link
                    :to="{ name: 'tools.landings.show', params: { id: item.id } }"
                    class="builder-box__pages-options-text"
                >
                    <div class="builder-box__pages-options-title">{{ item.title }}</div>
                    <template>
                        <div v-if="index % 2" class="builder-box__pages-options-subtitle">
                            123 try.platform.io/figmacourse/|Test 2
                        </div>
                        <div v-else class="builder-box__pages-options__error">
                            <v-icon src="info" /> Не выбран домен
                        </div>
                    </template>
                </router-link>

                <div class="builder-box__pages-options-devices">
                    <div class="builder-box__pages-options-devices-content">
                        <div class="builder-box__pages-options-device">
                            <!--    <div class="builder-box__pages-options-icon">
                                <v-icon src="desktop" />
                            </div>-->
                            <div class="builder-box__pages-options-icon">
                                <v-icon src="mini-mobile" />
                            </div>
                        </div>
                        <div class="builder-box__pages-options-device mt8">
                            <!--   <div class="builder-box__pages-options-icon">
                                <v-icon src="ok-green" />
                            </div>-->
                            <div class="builder-box__pages-options-icon">
                                <v-icon src="ok-green" />
                            </div>
                        </div>
                    </div>
                </div>
                <v-dropdown :append-id="`menu-dropdown-${index}`">
                    <button
                        type="button"
                        @click.prevent="$router.push({ name: 'tools.landings.edit.title', params: { id: item.id } })"
                    >
                        <v-icon src="edit" />
                        Изменить название
                    </button>
                    <button
                        type="button"
                        @click.prevent="$router.push({ name: 'tools.landings.preview', params: { id: item.id } })"
                    >
                        <v-icon src="eye" />
                        Предпросмотр
                    </button>
                    <button type="button">
                        <v-icon src="link" />
                        Получить ссылку
                    </button>
                    <button @click="destroy(item.id)" type="button">
                        <v-icon src="delete" />
                        Удалить
                    </button>
                </v-dropdown>
            </div>

            <v-paginate
                v-if="items.total > 0 && items.last_page > 1"
                :total="items.last_page"
                :current-page="items.current_page"
                @change="load"
            />
        </template>

        <template v-else>
            <div class="create-course-box__start-title">
                Вы еще не создали ни одной страницы
            </div>

            <div class="create-course-box__start-pic">
                <v-icon src="builder-start" />
            </div>

            <div class="create-course-box__start-action">
                <button type="button" @click="$router.push({ name: 'tools.landings.create' })" class="btn">
                    Создать страницу
                </button>
            </div>
        </template>

        <div v-if="items.total > 0" class="course-created__actions builder-mob-visible">
            <div class="course-created__action">
                <v-btn :to="{ name: 'tools.landings.create' }">Создать новую страницу</v-btn>
            </div>
        </div>
    </v-container>
</template>

<script>
import { api } from "../../services";

export default {
    name: "ToolsBuilderLandings",
    data() {
        return {
            loading: false,
            items: {
                data: [],
                current_page: 1,
                last_page: 1,
                per_page: 15,
                total: 0
            }
        };
    },
    mounted() {
        this.load();
    },
    methods: {
        load(page = 1) {
            this.loading = true;
            api.landings
                .all({ page })
                .then(({ data }) => (this.items = data))
                .finally(() => (this.loading = false));
        },
        destroy(id) {
            api.landings.destroy(id).then(() => {
                this.load();
            });
        }
    }
};
</script>

<style lang="scss">
.builder-box__pages-options-devices .open-btn {
    position: static;
}
.builder-box__pages-options {
    padding-right: 30px;
    &-icon:first-child {
        margin-right: 20px;
    }
    &-devices {
        display: block;
        &-content {
            width: auto;
        }
    }
    &__error {
        font-size: 12px;
        color: red;
        .icon-info {
            color: red !important;
        }
    }
}
.filter-field {
    margin-bottom: 24px;
    max-width: 350px;
}
/*.landing-list {
        list-style: none;
        padding: 0;
        &__item {
            display: flex;
            justify-content: space-between;
            background: #f5f7fa;
            border-radius: 4px;
            padding: 8px 42px 8px 16px;
            margin-bottom: 32px;
            position: relative;
            &-title {
                font-weight: 700;
                font-size: 16px;
                line-height: 24px;
                color: #1d2228;
                margin: 0;
            }
            &-subtitle {
                display: inline-block;
                font-weight: 500;
                font-size: 12px;
                line-height: 14px;
                color: #58606e;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                max-width: 200px;
            }
            &-devices {
                display: flex;
                margin-left: auto;
                .landing-devices-block {
                    &:first-child {
                        margin-right: 30px;
                    }
                    div {
                        margin-top: 10px;
                    }
                }
            }
        }
    }*/
</style>
